import { z } from 'zod';

/** Chuỗi 'YYYY-MM-DD' là một ngày có thật (dựng lại từ y-m-d phải ra đúng chuỗi; 2027-02-30 bị Date đẩy sang tháng 3 nên loại). */
export function isRealIsoDate(s: string): boolean {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(s)) return false;
  const d = new Date(`${s}T00:00:00Z`);
  return !Number.isNaN(d.getTime()) && d.toISOString().slice(0, 10) === s;
}

export const isRealMonth = (s: string) => /^\d{4}-(0[1-9]|1[0-2])$/.test(s);

// Giá trị sai (hoặc không phải chuỗi) coi như không có tham số — không làm hỏng route.
const lenient = (ok: (s: string) => boolean) =>
  z.unknown().transform((v) => (typeof v === 'string' && ok(v) ? v : undefined)).optional();

export const weekSearchParam = lenient(isRealIsoDate);
export const monthSearchParam = lenient(isRealMonth);
